import { render, staticRenderFns } from "./ProblemPassageHistory.vue?vue&type=template&id=650947da&scoped=true&lang=pug&"
import script from "./ProblemPassageHistory.vue?vue&type=script&lang=ts&"
export * from "./ProblemPassageHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemPassageHistory.vue?vue&type=style&index=0&id=650947da&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650947da",
  null
  
)

export default component.exports